/*
  Yulan TCG v3r (2026-09-30) - Alertes « retour en stock » avec l'application Kbite.
  Remplace la cloche maison (assets/yulan-alerts.js, conservé dans le thème mais plus chargé).

  - Fiche produit : Kbite insère lui-même son bouton « Me prévenir du retour en stock »
    (button.gw-button-widget) dans #yulan-kbite-slot (snippets/buy-buttons.liquid), ouvre sa fenêtre
    d'inscription et envoie l'e-mail au retour en stock. Réglages : Admin → Applications → Kbite.
  - Vignettes épuisées (grilles de collection, recherche, recommandations) : un lien « Me prévenir du retour »
    est ajouté sous le titre, vers la fiche du produit avec ?alerte=1. Les sections « Au fil des fêtes » et
    « Évoli » rendent le même lien en Liquid (snippets/yulan-alert-button.liquid).
  - Sur la fiche, ?alerte=1 ouvre directement la fenêtre Kbite dès que son bouton est prêt, puis le
    paramètre est retiré de l'adresse.
  - La fenêtre d'inscription Kbite reçoit une feuille de style aux couleurs du site et des libellés d'accessibilité
    en français (styleKbiteModals) ; à sa fermeture, le focus clavier revient au bouton qui l'a ouverte.
  - Fenêtre d'ajout rapide : lien « Me prévenir du retour en stock » quand la variante choisie est épuisée
    (syncQuickAdd), Kbite ne s'affichant que sur la fiche produit.
*/
(function () {
  'use strict';

  var LABEL = 'Me prévenir du retour';
  var TITLE = 'Être prévenu par e-mail du retour en stock';
  var BELL_SVG =
    '<span class="yulan-alert-btn__icon" aria-hidden="true"><svg class="icon icon-bell" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M18 8.4a6 6 0 0 0-12 0c0 6.6-2.5 8.6-2.5 8.6h17S18 15 18 8.4"/><path d="M13.7 20.5a2 2 0 0 1-3.4 0"/></svg></span>';

  function withAlert(href) {
    try {
      var url = new URL(href, location.origin);
      url.searchParams.set('alerte', '1');
      return url.pathname + url.search;
    } catch (e) {
      return href;
    }
  }

  /* ---------- vignettes : lien « Me prévenir du retour » sur les produits épuisés ---------- */
  function soldOutLabel() {
    var s = window.variantStrings && window.variantStrings.soldOut ? window.variantStrings.soldOut : 'Épuisé';
    return s.trim().toLowerCase();
  }

  function decorateCards() {
    var label = soldOutLabel();
    document.querySelectorAll('.product-card-wrapper:not([data-yulan-checked])').forEach(function (card) {
      card.setAttribute('data-yulan-checked', '');
      var badge = card.querySelector('.card__badge .badge');
      var soldOut = !!badge && badge.textContent.trim().toLowerCase() === label;
      if (!soldOut) {
        var qa = card.querySelector('.quick-add__submit[disabled]');
        soldOut = !!qa && qa.textContent.trim().toLowerCase().indexOf(label) >= 0;
      }
      if (!soldOut) return;
      var link = card.querySelector('.card__heading a[href]');
      if (!link || (link.getAttribute('href') || '').indexOf('/products/') < 0) return;
      var info = card.querySelector('.card > .card__content > .card__information');
      if (!info || info.parentNode.querySelector('.yulan-alert-btn')) return;
      var a = document.createElement('a');
      a.className = 'yulan-alert-btn yulan-alert-btn--card';
      a.href = withAlert(link.getAttribute('href'));
      a.rel = 'nofollow';
      a.title = TITLE;
      a.innerHTML = BELL_SVG + '<span class="yulan-alert-btn__label">' + LABEL + '</span>';
      info.insertAdjacentElement('afterend', a);
      card.setAttribute('data-yulan-soldout', '');
    });
  }

  function observeNewCards() {
    if (!window.MutationObserver) return;
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      // setTimeout plutôt que requestAnimationFrame : fonctionne aussi dans un onglet en arrière-plan.
      setTimeout(function () {
        scheduled = false;
        decorateCards();
        styleKbiteModals();
        syncQuickAdd();
      }, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- fenêtre d'inscription Kbite aux couleurs du site ----------
     Kbite l'affiche dans une iframe plein écran de même origine (iframe.gw-modal, contenu écrit par son
     script) : une feuille de style y est ajoutée (bouton rose en pilule, coins arrondis, textes nuit). */
  var MODAL_CSS =
    '.modal-container{border:0!important;border-radius:20px!important;box-shadow:0 12px 40px rgba(0,0,0,.35)!important;font-family:system-ui,-apple-system,"Segoe UI",Roboto,sans-serif!important}' +
    '.modal-title{color:#1a1424!important;font-weight:700!important}' +
    '.notification-message{color:#3d3548!important}' +
    '.email-input{border-radius:12px!important}' +
    '.notify-button{background-color:#e38ca0!important;color:#1a1424!important;border:0!important;border-radius:99px!important;font-weight:700!important;cursor:pointer}' +
    '.notify-button:hover{opacity:.92}' +
    '.privacy-text{color:#5b5566!important}' +
    // v3s : croix de fermeture lisible et zone de clic de 44 px (elle mesurait 10 × 15 px), lien confidentialité
    '.close-icon{display:inline-flex!important;align-items:center;justify-content:center;min-width:44px;min-height:44px;margin:-12px -12px 0 0;font-size:22px!important;line-height:1!important;color:#1a1424!important;opacity:1!important;cursor:pointer}' +
    '.yulan-privacy-link{color:#8a3a50!important;text-decoration:underline!important}';

  var FRAME_TITLES = {
    'gw-stock-fulfilled-iframe': 'Me prévenir du retour en stock',
    'gw-price-drop-iframe': 'Me prévenir d’une baisse de prix'
  };

  function styleKbiteModals() {
    document.querySelectorAll('iframe.gw-modal').forEach(function (frame) {
      // accessibilité : nom de la fenêtre, langue et bouton de fermeture en français (Kbite les laisse en anglais)
      var title = FRAME_TITLES[frame.id];
      if (title && frame.title !== title) frame.title = title;
      var doc = null;
      try {
        doc = frame.contentDocument;
      } catch (e) {
        return;
      }
      if (!doc || !doc.head) return;
      if (doc.documentElement && doc.documentElement.lang !== 'fr') doc.documentElement.lang = 'fr';
      var close = doc.querySelector('.close-icon');
      if (close && close.getAttribute('aria-label') !== 'Fermer') close.setAttribute('aria-label', 'Fermer');
      enhanceKbiteDoc(doc);
      if (doc.getElementById('yulan-kbite-css')) return;
      var style = doc.createElement('style');
      style.id = 'yulan-kbite-css';
      style.textContent = MODAL_CSS;
      doc.head.appendChild(style);
    });
  }

  /* ---------- v3s : fermeture par Échap ou clic sur le fond, lien vers la politique de confidentialité ---------- */
  function closeKbite(doc) {
    var c = doc && doc.querySelector('.close-icon');
    if (c) c.click();
  }

  function enhanceKbiteDoc(doc) {
    // Kbite promet « Nous ne partageons jamais votre adresse e-mail » sans renvoi vers la politique : on l'ajoute
    var privacy = doc.querySelector('.privacy-text');
    if (privacy && !privacy.querySelector('.yulan-privacy-link')) {
      var a = doc.createElement('a');
      a.className = 'yulan-privacy-link';
      a.href = '/policies/privacy-policy';
      a.target = '_top';
      a.textContent = 'Politique de confidentialité';
      privacy.appendChild(doc.createTextNode(' '));
      privacy.appendChild(a);
    }
    if (doc.__yulanEnhanced) return;
    doc.__yulanEnhanced = true;
    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') closeKbite(doc);
    });
    doc.addEventListener('click', function (e) {
      var box = doc.querySelector('.modal-container');
      if (box && e.target && e.target.nodeType === 1 && !box.contains(e.target)) closeKbite(doc);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    document.querySelectorAll('iframe.gw-modal').forEach(function (frame) {
      if (getComputedStyle(frame).display === 'none') return;
      try {
        closeKbite(frame.contentDocument);
      } catch (err) {
        /* iframe inaccessible : rien à faire */
      }
    });
  });

  /* ---------- à la fermeture de la fenêtre Kbite, rendre le focus clavier au bouton qui l'a ouverte ---------- */
  var lastOpener = null;
  var closeWatcher = null;

  function watchKbiteClose() {
    if (closeWatcher) closeWatcher.disconnect();
    var frame = document.getElementById('gw-stock-fulfilled-iframe');
    if (!frame || !window.MutationObserver) return;
    var seenOpen = getComputedStyle(frame).display !== 'none';
    closeWatcher = new MutationObserver(function () {
      if (getComputedStyle(frame).display !== 'none') {
        seenOpen = true;
        return;
      }
      if (!seenOpen) return;
      closeWatcher.disconnect();
      closeWatcher = null;
      var active = document.activeElement;
      if (lastOpener && document.contains(lastOpener) && (!active || active === document.body || active === frame)) {
        try {
          lastOpener.focus({ preventScroll: true });
        } catch (e) {
          /* élément non focalisable : rien à faire */
        }
      }
    });
    closeWatcher.observe(frame, { attributes: true, attributeFilter: ['style', 'class'] });
  }

  // à l'ouverture (Kbite peut réécrire le contenu de l'iframe) : on réapplique juste après le clic
  document.addEventListener(
    'click',
    function (e) {
      var widget = e.target && e.target.closest ? e.target.closest('.gw-button-widget') : null;
      if (!widget) return;
      // bouton de la barre d'achat mobile (qui relaie le clic) ou, à défaut, le bouton Kbite lui-même
      var active = document.activeElement;
      lastOpener = active && active !== document.body && active.tagName !== 'IFRAME' ? active : widget;
      setTimeout(styleKbiteModals, 0);
      setTimeout(styleKbiteModals, 300);
      setTimeout(styleKbiteModals, 1000);
      watchKbiteClose();
    },
    true
  );

  /* ---------- ajout rapide (fenêtre « Choisir des options » des vignettes) ----------
     Kbite ne dessine son bouton que sur la fiche produit : il suit l'adresse de la page, que la fenêtre
     d'ajout rapide ne change pas. Quand la variante choisie y est épuisée, on ajoute donc dans l'emplacement
     recopié un lien « Me prévenir du retour en stock » vers la fiche de cette variante (?variant=…&alerte=1),
     où la fenêtre Kbite s'ouvre directement sur la bonne variante. */
  var FULL_LABEL = 'Me prévenir du retour en stock';

  function syncQuickAdd() {
    document.querySelectorAll('quick-add-modal .yulan-kbite-slot').forEach(function (slot) {
      var info = slot.closest('product-info');
      var submit = info ? info.querySelector('[name="add"]') : null;
      var idInput = info ? info.querySelector('input.product-variant-id') : null;
      var url = info ? info.getAttribute('data-url') : '';
      var soldOut = !!submit && submit.hasAttribute('disabled') && !!idInput && !!idInput.value && !!url;
      var link = slot.querySelector('a.yulan-alert-btn');
      if (!soldOut) {
        if (link) link.remove();
        return;
      }
      var href = url + '?variant=' + encodeURIComponent(idInput.value) + '&alerte=1';
      if (!link) {
        link = document.createElement('a');
        link.className = 'yulan-alert-btn yulan-alert-btn--full';
        link.rel = 'nofollow';
        link.title = TITLE;
        link.innerHTML = BELL_SVG + '<span class="yulan-alert-btn__label">' + FULL_LABEL + '</span>';
        slot.appendChild(link);
      }
      if (link.getAttribute('href') !== href) link.setAttribute('href', href);
    });
  }

  function initVariantSync() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      setTimeout(syncQuickAdd, 0);
    });
  }

  /* ---------- fiche produit : ?alerte=1 ouvre la fenêtre Kbite ---------- */
  function openFromUrl() {
    var url;
    try {
      url = new URL(location.href);
    } catch (e) {
      return;
    }
    if (url.searchParams.get('alerte') !== '1') return;
    url.searchParams.delete('alerte');
    if (window.history && history.replaceState) history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    if (!document.getElementById('yulan-kbite-slot')) return;
    var tries = 0;
    (function waitForKbite() {
      var btn = document.querySelector('#yulan-kbite-slot .gw-button-widget');
      // attendre aussi que la fenêtre Kbite soit montée (application Vue dans l'iframe) : cliquer avant
      // provoque une erreur dans le script Kbite et une fenêtre sans variante sélectionnée
      var app = window.growCampaignPopUps && window.growCampaignPopUps['gw-stock-fulfilled-iframe'];
      if (btn && btn.offsetParent !== null && app) {
        btn.scrollIntoView({ block: 'center' });
        btn.click();
        return;
      }
      tries += 1;
      if (tries < 60) setTimeout(waitForKbite, 250); // 15 s au plus
    })();
  }

  function init() {
    decorateCards();
    styleKbiteModals();
    syncQuickAdd();
    observeNewCards();
    initVariantSync();
    openFromUrl();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
